"use client";

// ---------- Pusher Config ----------
export interface PusherConfig {
  key: string;
  wsHost: string;
  wsPort?: number;
  wssPort?: number;
  forceTLS: boolean;
  wsPath?: string;
}

const defaultPusherUrl = "ws://127.0.0.1:6001?key=app-key";

export function getPusherConfig(): PusherConfig {
  const url = process.env.NEXT_PUBLIC_PUSHER_URL || defaultPusherUrl;
  const urlObj = new URL(url);
  const forceTLS = urlObj.protocol === "wss:";
  const wsHost = urlObj.hostname;
  const key = urlObj.searchParams.get("key") || "app-key";
  let wsPort = undefined;
  let wssPort = undefined;
  if (forceTLS) {
    wssPort = urlObj.port ? parseInt(urlObj.port) : 443;
  } else {
    wsPort = urlObj.port ? parseInt(urlObj.port) : 80;
  }
  const wsPath = urlObj.pathname === "/" ? undefined : urlObj.pathname;
  return {
    wsHost,
    wsPort,
    wssPort,
    key,
    forceTLS,
    wsPath,
  };
}

export function getDPBaseUrl() {
  return (
    process.env.NEXT_PUBLIC_DATA_PLATFORM_API_URL ?? "http://localhost:8010"
  );
}

export function getHocuspocusUrl(): string {
  const localYjsUrl = getDebugYjsUrl();
  if (localYjsUrl) {
    return localYjsUrl;
  }
  return process.env.NEXT_PUBLIC_YJS_URL ?? "ws://localhost:4400";
}

const debugYjsKey = "debug-yjs";

function getDebugYjsUrl(): string | null {
  try {
    return localStorage.getItem(debugYjsKey);
  } catch (e) {
    console.error("Error fetch Yjs URL", e);
    return null;
  }
}

export function getCustomPortalBaseUrl() {
  return process.env.NEXT_PUBLIC_PORTAL_API_URL ?? "http://localhost:5174";
}
